const baseStyleList = () => {
  return {
    // Chakra's menu sets `--menu-bg: #fff` (a literal); point it at the token.
    '--menu-bg': 'colors.white',
    borderWidth: '1px',
    borderColor: 'light.border',
    boxShadow: 'light.primary',
    padding: '8px',
    borderRadius: '10px',
  };
};

const baseStyleItem = () => {
  return {
    borderRadius: '6px',
    fontSize: '14px',
    _focus: { bg: 'menu-hover', fontWeight: 700 },
    _hover: { bg: 'menu-hover', fontWeight: 700 },
  };
};

const baseStyle = () => ({
  list: baseStyleList(),
  item: baseStyleItem(),
});

export const Menu = {
  baseStyle,
};
